<template>
  <div id="nav">
    <router-link to="/">全球手机号生成器</router-link> |
    <router-link to="/timezone">时区转换</router-link> |
    <router-link to="/uuid">uuid生成器</router-link> |
    <router-link to="/ip">ip查询</router-link>
  </div>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
